

import React, { PureComponent } from "react";
import styles from "./ClanBalance.scss";

import { t } from "../../../helpers/localization";
import { thousands } from "../../../helpers/formatting";

import { Balance } from "../../../Reducers/ReducerTreasury";

export type ClanBalance_Props = {
  totalBalanceList: Balance;
};

import { Spinner, StepCSSTransitionGroup } from "@wg/wows-react-uikit";

import { currencyNames } from "fe2/Components/UIKit/Currency/Currency";

class ClanBalance extends PureComponent<ClanBalance_Props, any> {

  render() {
    return <div className={styles.wrapper}>
                {this.props.totalBalanceList.length > 0 ? this.props.totalBalanceList.map((item, index) => {
        if (currencyNames[item.type]) {
          return <StepCSSTransitionGroup level={index + 1} key={`Balance${index}`}>
                                <div className={styles.currency}>
                                    <div className={styles.amount}>
                                        <div className={styles.value}>
                                            {thousands(item.amount)}
                                        </div>
                                        <div className={`${styles.icon} ${styles[item.type]}`} />
                                    </div>
                                    <div className={styles.label}>
                                        {currencyNames[item.type]}
                                    </div>
                                </div>
                            </StepCSSTransitionGroup>;
        } else {
          return null;
        }

      }) : <div className={styles.spinnerWrapper}>
                        <Spinner label={t('Идет загрузка баланса')} />
                    </div>}
            </div>;
  }
}

export default ClanBalance;